import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import {
  ExpandableButton,
  SecondaryButton,
  TertiaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import {
  ExpandableMenu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import EditIcon from '@grnhse/seedling/lib/birch/icons/edit';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import type { SavedSearchItem } from 'talent_search/shared/types';

const t = withLocalePrefix('talent_matching.filter_row.saved_filters');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

const StyledMenuButton = styled(MenuButton)`
  white-space: nowrap;
`;

type Props = {
  savedFilterSet: SavedSearchItem | null;
  onLoadFilters?: () => void;
  onSaveFilters?: () => void;
  onUpdateFilters?: () => void;
};

const SavedFilterButtons = ({
  savedFilterSet,
  onLoadFilters,
  onSaveFilters,
  onUpdateFilters,
}: Props) => {
  const showExpandableMenu = savedFilterSet && onUpdateFilters;

  return (
    <NoWrap spacing={1} direction="row" alignItems="center">
      {savedFilterSet ? (
        <TertiaryButton
          size="md"
          onClick={onLoadFilters}
          icon={EditIcon}
          placement="right"
        >
          {savedFilterSet.label}
        </TertiaryButton>
      ) : (
        <TertiaryButton size="md" onClick={onLoadFilters}>
          {t('load')}
        </TertiaryButton>
      )}
      {showExpandableMenu ? (
        <ExpandableMenu>
          <ExpandableButton as={StyledMenuButton} size="md">
            {t('save_filters')}
          </ExpandableButton>
          <MenuList>
            <MenuItem onSelect={() => onUpdateFilters?.()}>
              {t('save_changes', { name: savedFilterSet.label })}
            </MenuItem>
            <MenuItem onSelect={() => onSaveFilters?.()}>
              {t('save_as')}
            </MenuItem>
          </MenuList>
        </ExpandableMenu>
      ) : (
        <SecondaryButton size="md" onClick={onSaveFilters}>
          {t('save_filters')}
        </SecondaryButton>
      )}
    </NoWrap>
  );
};

export default SavedFilterButtons;
